import { WIDTH_X_HEIGHT_REGEX } from '@monoimin/constants';
import { AssetStoryblok } from '@monoimin/sb-types';

const EMPTY = {
  width: undefined,
  height: undefined,
};

export const getAssetImageDimensions = (item?: AssetStoryblok) => {
  if (!item?.filename) {
    return EMPTY;
  }

  const match = item.filename.match(WIDTH_X_HEIGHT_REGEX);

  if (!match) {
    return EMPTY;
  }

  const [first] = match;

  const [width, height] = first.split('x');

  return {
    width: Number(width),
    height: Number(height),
  };
};

export default getAssetImageDimensions;
